import { temAcesso } from '@/shared/auth/temAcesso'

const Aplicacoes = () => import('./Aplicacoes')
const AplicacoesForm = () => import('./AplicacoesForm')
// const PerfilRegrasAcesso = () => import('./PerfilRegrasAcesso')

export default {
    path: 'aplicacoes',
    name: 'Aplicacoes',
    component: Aplicacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-APP-00')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'Aplicacoes_Inserir',
            component: AplicacoesForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-APP-01')) {
                    next()
                }
            }
        },
        {
            path: ':aplicacaoId/detalhar',
            name: 'Aplicacoes_Detalhar',
            component: AplicacoesForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-APP-02')) {
                    next()
                }
            }
        },
        {
            path: ':aplicacaoId/atualizar',
            name: 'Aplicacoes_Atualizar',
            component: AplicacoesForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-APP-03')) {
                    next()
                }
            }
        }
        // {
        //     path: 'atualizar/:perfilAcessoId',
        //     name: 'PerfisAcesso_Atualizar',
        //     component: PerfisAcessoForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CTRLACS-PA-03')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: 'regrasacesso/:perfilAcessoId',
        //     name: 'PerfisAcesso_RegrasAcesso',
        //     component: PerfilRegrasAcesso,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CTRLACS-PA-05')) {
        //             next()
        //         }
        //     }
        // }
    ]
}
